import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { FeatureBase } from './feature-base';
import { isValid } from '../../common/config/info';
import { configure } from '../../loaders/configure/configure';
import { gosCDN } from '../../common/window/nreum';
import { drain as _drain } from '../../common/drain/drain';
import { activatedFeatures } from '../../common/util/feature-flags';
import { Obfuscator } from '../../common/util/obfuscate';
import { EventBuffer } from './event-buffer';
import { FEATURE_NAMES } from '../../loaders/features/features';
export var AggregateBase = /*#__PURE__*/function (_FeatureBase) {
  _inherits(AggregateBase, _FeatureBase);

  var _super = _createSuper(AggregateBase);

  function AggregateBase(agentRef, featureName) {
    var _this;

    _classCallCheck(this, AggregateBase);

    _this = _super.call(this, agentRef.agentIdentifier, featureName);
    _this.agentRef = agentRef; // Jserror and Metric features uses a singleton EventAggregator instead of a regular EventBuffer.

    if ([FEATURE_NAMES.jserrors, FEATURE_NAMES.metrics].includes(_this.featureName)) _this.events = agentRef.sharedAggregator; // PVE has no need for eventBuffer, and SessionTrace has its own storage mechanism.
    else if (![FEATURE_NAMES.pageViewEvent, FEATURE_NAMES.sessionTrace].includes(_this.featureName)) _this.events = new EventBuffer();

    _this.checkConfiguration(agentRef);

    _this.obfuscator = agentRef.runtime.obfuscator;
    return _this;
  }
  /**
   * New handler for waiting for multiple flags. Useful when expecting multiple flags simultaneously (ex. stn vs sr)
   * @param {string[]} flagNames
   * @returns {Promise}
   */


  _createClass(AggregateBase, [{
    key: "waitForFlags",
    value: function waitForFlags() {
      var _this2 = this;

      var flagNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var flagsPromise = new Promise(function (resolve, reject) {
        if (activatedFeatures[_this2.agentIdentifier]) {
          resolve(buildOutput(activatedFeatures[_this2.agentIdentifier]));
        } else {
          _this2.ee.on('rumresp', function () {
            var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            resolve(buildOutput(resp));
          });
        }

        function buildOutput(ref) {
          return flagNames.map(function (flag) {
            if (!ref[flag]) return 0;
            return ref[flag];
          });
        }
      });
      return flagsPromise.catch(function (err) {
        _this2.ee.emit('internal-error', [err]);

        _this2.blocked = true;

        _this2.deregisterDrain();
      });
    }
  }, {
    key: "drain",
    value: function drain() {
      _drain(this.agentIdentifier, this.featureName);

      this.drained = true;
    }
    /**
     * Return harvest payload. A "serializer" function can be defined on a derived class to format the payload.
     * @param {Boolean} shouldRetryOnFail - harvester flag to backup payload for retry later if harvest request fails; this should be moved to harvester logic
     * @returns final payload, or undefined if there are no pending events
     */

  }, {
    key: "makeHarvestPayload",
    value: function makeHarvestPayload() {
      var shouldRetryOnFail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.events.isEmpty(opts)) return; // Other conditions and things to do when preparing harvest that is required.

      if (this.preHarvestChecks && !this.preHarvestChecks()) return;
      if (shouldRetryOnFail) this.events.save(opts);
      var returnedData = this.events.get(opts); // A serializer or formatter assists in creating the payload `body` from stored events on harvest when defined by derived feature class.

      var body = this.serializer ? this.serializer(returnedData) : returnedData;
      this.events.clear(opts);
      var payload = {
        body: body
      }; // Constructs the payload `qs` for relevant features on harvest.

      if (this.queryStringsBuilder) payload.qs = this.queryStringsBuilder(returnedData);
      return payload;
    }
    /**
     * Cleanup task after a harvest.
     * @param {Boolean} harvestFailed - harvester flag to restore events in main buffer for retry later if request failed
     */

  }, {
    key: "postHarvestCleanup",
    value: function postHarvestCleanup() {
      var harvestFailed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (harvestFailed) this.events.reloadSave(opts);
      this.events.clearSave(opts);
    }
    /**
     * Checks for additional `jsAttributes` items to support backward compatibility with implementations of the agent where
     * loader configurations may appear after the loader code is executed.
     */

  }, {
    key: "checkConfiguration",
    value: function checkConfiguration(existingAgent) {
      // NOTE: This check has to happen at aggregator load time
      if (!isValid(this.agentIdentifier)) {
        var _cdn$info;

        var cdn = gosCDN();

        var jsAttributes = _objectSpread({}, (_cdn$info = cdn.info) === null || _cdn$info === void 0 ? void 0 : _cdn$info.jsAttributes);

        try {
          var _existingAgent$info;

          jsAttributes = _objectSpread(_objectSpread({}, jsAttributes), (_existingAgent$info = existingAgent.info) === null || _existingAgent$info === void 0 ? void 0 : _existingAgent$info.jsAttributes);
        } catch (err) {// do nothing
        }

        configure({
          agentIdentifier: this.agentIdentifier
        }, _objectSpread(_objectSpread({}, cdn), {}, {
          info: _objectSpread(_objectSpread({}, cdn.info), {}, {
            jsAttributes: jsAttributes
          }),
          runtime: existingAgent.runtime
        }));
      }

      if (!existingAgent.runtime.obfuscator) {
        existingAgent.runtime.obfuscator = new Obfuscator(this.agentIdentifier);
      }
    }
  }]);

  return AggregateBase;
}(FeatureBase);